import { Incoterms } from '../../schemas';

const PORT_OF_DISCHARGE_REQUIRED: Incoterms[] = [
  Incoterms.CFR,
  Incoterms.CIF,
  Incoterms.CPT,
  Incoterms.CIP,
  Incoterms.DAP,
  Incoterms.DDP,
];

const PORT_OF_LOADING_REQUIRED: Incoterms[] = [
  Incoterms.FAS,
  Incoterms.FOB,
  Incoterms.CFR,
  Incoterms.CIF,
  Incoterms.EXW,
];

export const isPortOfDischargeRequired = (incoterm: Incoterms) => {
  return PORT_OF_DISCHARGE_REQUIRED.includes(incoterm);
};

export const isPortOfLoadingRequired = (incoterm: Incoterms) => {
  return PORT_OF_LOADING_REQUIRED.includes(incoterm);
};
